import { createContext, useContext, useState } from 'react';
import { api } from '../api/client';
import { setSession, clearSession, getUser } from '../utils/auth.helpers';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(getUser());

  async function login(email, password) {
    const data = await api.post('/auth/login', { email, password });
    setSession(data.access_token, data.user);
    setUser(data.user);
    return data.user;
  }

  function logout() {
    clearSession();
    setUser(null);
  }

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
